import React, { useContext, useState } from 'react'
import { BiX, BiChevronLeft, BiChevronRight, BiImage, BiBox } from 'react-icons/bi'
import { BtnNextImg, BtnOptionsCard, ContImgCard } from '../../../../../../../assets/css/components/admin/marketplace-to-marketplace/cardItem/CardItemStyle';
import { GlobalContext } from '../../../../../../../contexts/GlobalContext';

export default function CardContImage({ urlImage, id }) {
    const [imgPosition, setImgPosition] = useState(0);
    const globalContext = useContext(GlobalContext)

    const deleteItem = (data) => {
        let copyArr = [...globalContext.listProductsToSend];
        //? buscamos el valor a ver si ya existe
        const existId = copyArr.find(v => v._id === data);
        if (existId) {
            const newData = copyArr.filter(v => v._id !== data);
            globalContext.setListProductsToSend(newData);
        }
    }

    const nextImg = () => {
        if (!urlImage?.length) return;
        const maxImg = urlImage.length - 1;
        if (imgPosition === maxImg) return;
        setImgPosition(imgPosition + 1);
    }
    const backImg = () => {
        if (!urlImage?.length) return;
        if (imgPosition === 0) return;
        setImgPosition(imgPosition - 1);
    }
    //console.log('la img q llega', urlImage)
    const hasImage = urlImage && urlImage.length > 0 && urlImage[imgPosition];
    
    return (
        <ContImgCard url={hasImage ? urlImage[imgPosition] : ''}>
            {!hasImage && <BiBox size="86px" color="#cbd5e1" />}
            <BtnOptionsCard onClick={() => deleteItem(id)}>
                <BiX />
            </BtnOptionsCard>
            {
                imgPosition > 0 && (
                    <BtnNextImg onClick={() => backImg()}>
                        <BiChevronLeft />
                    </BtnNextImg>
                )
            }
            {
                (urlImage?.length > 1 && imgPosition < urlImage.length - 1) && (
                    <BtnNextImg l="auto" r="10px" onClick={() => nextImg()}>
                        <BiChevronRight />
                    </BtnNextImg>
                )
            }
        </ContImgCard>
    )
}
